import { render, staticRenderFns } from "./form-unit-checkbox.vue?vue&type=template&id=52fc6aec&"
import script from "./form-unit-checkbox.vue?vue&type=script&lang=js&"
export * from "./form-unit-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports